export default "__VITE_ASSET__Cnx79yqz__"